import { render, staticRenderFns } from "./MenuItemSMS.vue?vue&type=template&id=3e68f532&scoped=true&"
import script from "./MenuItemSMS.vue?vue&type=script&lang=js&"
export * from "./MenuItemSMS.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemSMS.vue?vue&type=style&index=0&id=3e68f532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68f532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3e68f532', component.options)
    } else {
      api.reload('3e68f532', component.options)
    }
    module.hot.accept("./MenuItemSMS.vue?vue&type=template&id=3e68f532&scoped=true&", function () {
      api.rerender('3e68f532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItemSMS.vue"
export default component.exports